import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import InputFeedback from '../../../../common/form/InputFeedback';
import './ItemButton.css';

const ItemButton = ({
  field,
  form: { touched, errors },
  label,
  options,
  className,
  handler,
  isWriting,
  ...props
}) => {
  const { name } = field;
  const error = _.get(touched, name) && _.get(errors, name);

  const classes = classnames(
    'input-group radioSelect buttonField switchField field',
    { error: !!error },
    className
  );

  const enhancedOnChange = handler
    ? (e, category) => {
      field.onChange(e);
      handler(e, category);
    }
    : field.onChange;

  return (
    <div className={classes}>
      <div className="switchField-title label buttonImage">{label}</div>

      {options.map(o => [
        <input
          type="radio"
          className="radio-input radio"
          id={o.label}
          key={`${o.label}-i`}
          {...field}
          {...props}
          isActive={!isWriting}
          isDisabled={isWriting}
          onChange={(e) => {
            enhancedOnChange(e, o.value);
          }}
          value={o.value}
        />,

        <label id={o.id} htmlFor={o.label} key={`${o.label}-l`}>
          <div className="labelHolderText">
            {o.label}
          </div>
        </label>,

      ])}

      <InputFeedback error={error} />
    </div>
  );
};

ItemButton.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  form: PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.object,
  }).isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  className: PropTypes.string,
  handler: PropTypes.func,
  isWriting: PropTypes.bool,
};

ItemButton.defaultProps = {
  label: '',
  className: '',
  handler: null,
  isWriting: false,
};

export default ItemButton;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/addForms/ItemButton.jsx